'use strict';
(() => {
  if (customElements.get('oluvie-recently-viewed')) return;
  document.querySelectorAll('[data-or-recent]').forEach((section) => {
    if (section.dataset.orRecentValidated) return;
    section.dataset.orRecentValidated = 'true';
    const core = window.OluvieRecentCore;
    const config = JSON.parse(section.querySelector('[data-or-recent-config]').textContent);
    const track = section.querySelector('[data-or-recent-track]');
    const previous = section.querySelector('[data-or-recent-previous]');
    const next = section.querySelector('[data-or-recent-next]');
    let storage = null; try { storage = window.localStorage; } catch (_) {}
    let records = core.read(storage, config.limit), generation = 0;
    const verified = new Map(), blocked = new Set();
    const key = record => record.product.id + ':' + record.product.handle.toLowerCase();
    const money = new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency });
    function render() {
      const visible = core.visible(records, config.current.product.id, config.limit).filter(record => verified.has(key(record)));
      track.replaceChildren();
      for (const record of visible) {
        const value = core.validate(record, verified.get(key(record)));
        if (value.status !== 'ok') continue;
        const { product, variant } = value;
        const link = document.createElement('a'); link.className = 'or-recent__card';
        const url = new URL((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(product.handle), location.origin);
        if (variant) url.searchParams.set('variant', variant.id);
        link.href = url.pathname + url.search;
        const image = document.createElement('img');
        const imageSource = variant?.featured_image?.src || product.featured_image;
        let imageUrl;
        try { imageUrl = new URL(imageSource, location.origin); } catch (_) {}
        if (typeof imageSource === 'string' && imageUrl && ['https:', 'http:'].includes(imageUrl.protocol)) {
          if (imageUrl.hostname === 'cdn.shopify.com') {
            const sized = width => { const url = new URL(imageUrl.href); url.searchParams.set('width', width); return url.href; };
            image.src = sized(440);
            image.srcset = [220, 440, 660].map(width => sized(width) + ' ' + width + 'w').join(', ');
            image.sizes = '(max-width: 767px) 72vw, 280px';
          } else image.src = imageUrl.href;
        } else image.hidden = true;
        image.alt = product.title; image.loading = 'lazy'; image.decoding = 'async';
        const detail = document.createElement('span'); const title = document.createElement('b'); title.textContent = product.title; const price = document.createElement('strong'); price.textContent = money.format((variant?.price || 0) / 100); detail.append(title, price); link.append(image, detail); track.append(link);
      }
      section.hidden = track.childElementCount === 0; track.hidden = section.hidden; requestAnimationFrame(syncControls);
    }
    async function validate() {
      const current = ++generation;
      track.setAttribute('aria-busy', 'true');
      verified.clear(); render();
      const visible = core.visible(records, config.current.product.id, config.limit);
      await Promise.all(visible.map(async record => {
        const identity = key(record);
        if (blocked.has(identity) || !window.OluvieProductLookup) return;
        const result = await window.OluvieProductLookup.read(record.product.handle).catch(() => ({ status: 'transient' }));
        if (current !== generation || !section.isConnected) return;
        const value = core.validate(record, result);
        if (value.status === 'missing') {
          core.evict(storage, record);
          records = records.filter(item => key(item) !== identity);
        } else if (value.status === 'transient') blocked.add(identity);
        else verified.set(identity, result);
        render();
      }));
      if (current === generation && section.isConnected) track.setAttribute('aria-busy', 'false');
    }
    function store(raw) { if (!section.isConnected) return; records = core.touch(records, raw, config.limit); core.write(storage, records); void validate(); }
    function syncControls() { const overflow = track.scrollWidth > track.clientWidth + 2; previous.hidden = !overflow || track.scrollLeft <= 2; next.hidden = !overflow || Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 2; }
    previous.addEventListener('click', () => track.scrollBy({ left: -Math.max(220, track.clientWidth * .75), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: Math.max(220, track.clientWidth * .75), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', syncControls, { passive: true }); window.addEventListener('resize', syncControls);
    window.addEventListener('pagehide', () => { generation += 1; verified.clear(); track.replaceChildren(); section.hidden = true; });
    window.addEventListener('pageshow', event => { if (event.persisted && section.isConnected) { blocked.clear(); void validate(); } });
    document.addEventListener('oluvie:product-view', (event) => { if (event.detail?.product) store(event.detail); });
    store(config.current);
  });
})();
